
import React, { useRef, useEffect } from 'react';
import { NewsItem } from '../../types';

interface NewsFeedProps {
    newsFeed: NewsItem[];
    aiEnabled: boolean;
}

const NewsFeed: React.FC<NewsFeedProps> = ({ newsFeed, aiEnabled }) => {
    const newsRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (newsRef.current) {
        newsRef.current.scrollTop = newsRef.current.scrollHeight;
        }
    }, [newsFeed]);

    return (
        <div className="w-full md:w-80 h-32 md:h-48 bg-black/90 text-white rounded-xl border border-slate-700/80 backdrop-blur-xl shadow-2xl flex flex-col overflow-hidden relative">
            <div className="bg-slate-800/90 px-3 py-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-300 border-b border-slate-600 flex justify-between items-center">
            <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></span>
                Security Feed
            </span>
            <span className="font-mono text-[9px] opacity-50">LIVE</span>
            </div>
            
            <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(to_bottom,rgba(0,255,255,0.03)_50%,rgba(0,0,0,0)_50%)] bg-[length:100%_4px] z-20"></div>
            
            <div ref={newsRef} className="flex-1 overflow-y-auto p-2 md:p-3 space-y-2 text-[10px] md:text-xs font-mono scroll-smooth mask-image-b z-10">
            {newsFeed.length === 0 && <div className="text-slate-500 italic text-center mt-10">Secure channel quiet.</div>}
            {newsFeed.map((news) => (
                <div key={news.id} className={`
                border-l-2 pl-2 py-1 transition-all animate-fade-in leading-tight relative
                ${news.type === 'positive' ? 'border-green-500 text-green-300 bg-green-900/10' : ''}
                ${news.type === 'negative' ? 'border-red-500 text-red-300 bg-red-900/10' : ''}
                ${news.type === 'neutral' ? 'border-cyan-400 text-cyan-200 bg-cyan-900/10' : ''}
                `}>
                <span className="opacity-50 text-[8px] absolute top-0.5 right-1">{new Date(Number(news.id.split('.')[0])).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                {news.text}
                </div>
            ))}
            </div>
        </div>
    );
};

export default NewsFeed;
